import { render, staticRenderFns } from "./ProviderItem.vue?vue&type=template&id=3df48da7&scoped=true&"
import script from "./ProviderItem.vue?vue&type=script&lang=js&"
export * from "./ProviderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df48da7",
  null
  
)

export default component.exports